export default {
  SnakegameTitle: '词汇贪食蛇设置',
  topic: '主题(即游戏活动名称)',
  inputTopic: '请输入游戏主题名称',
  correctItems: '答对题目',
  correctItemsPlaceholder: '输入正答词汇，可用换行或逗号(,)分隔，按下Enter确认新增项目',
  errorItems: '答错题目',
  errorItemsPlaceholder: '输入错误词汇，可用换行或逗号(,)分隔，按下Enter确认新增项目',
  difficulty: '难度等级',
  difficultyEasy: '简单',
  difficultyMedium: '中等',
  difficultyHard: '困难',
  boardSize: '棋盘大小',
  snakeSpeed: '蛇移动速度',
  foodCount: '食物数量',
  items: '个',
  gameDuration: '游戏时长',
  second: '秒',
  clearData: '清空数据',
  saveSettings: '保存设置',
  wordExists: '此词汇已存在',
  maxVocabulary: '正确词汇数量已达上限 (20个)',
  maxErrorVocabulary: '错误词汇数量已达上限 (20个)',
  dataCleared: '数据已清空',
  settingsSaved: '设置已保存',
  pleaseCompleteSettings: '请完成所有必填项目（至少需要5个正确词汇和5个错误词汇）',
  unsubmittedWarning: '发现输入框中尚有未按下Enter 的词汇，请确认后再进行操作!',
  gamePaused: '活动暂停',
  gameOver: '游戏结束',
  showAnswers: '查看答案',
  referenceAnswers: '参考答案',
  maxLength: '最长长度',
  leftPlayer: '左侧玩家',
  rightPlayer: '右侧玩家',
  sendSuccess: '游戏资料已成功推送！',
  sendCooldown: '已按过送出，请等候1分钟才可再操作',
  pushSuccess: '游戏短网址已成功推送！',
  pushFailed: '推送失败：{message}',
  tokenRefreshing: '正在刷新授权资讯，请稍后再试...',
};
